import { useState } from "react";
import { IconButton, Box, AppBar, useMediaQuery, Toolbar, styled, Stack } from "@mui/material";
import { IconMenu2 } from "@tabler/icons-react";
import { useDispatch } from "react-redux";
import SmartAlertsDropdown from "../../ai/SmartAlertsDropdown";
import Search from "./Search";
import { toggleMobileSidebar, toggleSidebar, toggleSidebarCollapse } from "../../../redux/action";
import Navigation from "./Navigation";
import Profile from "./Profile";
import MobileRightSidebar from "./MobileRightSidebar";

const AppBarStyled = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  background: theme.palette.background.paper,
  justifyContent: "center",
  backdropFilter: "blur(4px)",
  [theme.breakpoints.up("lg")]: {
    minHeight: 70,
  },
}));
const ToolbarStyled = styled(Toolbar)(({ theme }) => ({
  width: "100%",
  color: theme.palette.text.secondary,
}));

export function Header() {
  const lgUp = useMediaQuery(theme => theme.breakpoints.up("lg"));
  const lgDown = useMediaQuery(theme => theme.breakpoints.down("lg"));
  const [alignment, setAlignment] = useState("");

  // drawer
  const dispatch = useDispatch();

  return (
    <AppBarStyled position="sticky" color="default">
      <ToolbarStyled>
        {/* ------------------------------------------- */}
        {/* Toggle Button Sidebar */}
        {/* ------------------------------------------- */}
        <IconButton
          color="inherit"
          aria-label="menu"
          onClick={() => {
            if (lgUp) {
              dispatch(toggleSidebar());
              dispatch(toggleSidebarCollapse());
            } else {
              dispatch(toggleMobileSidebar());
            }
          }}
          sx={{ "&:focus": { outline: "none" } }}
          onFocus={e => e.target.blur()}
        >
          <IconMenu2 size="20" />
        </IconButton>

        {/* ------------------------------------------- */}
        {/* Search Dropdown */}
        {/* ------------------------------------------- */}
        <Search />
        {lgUp && <Navigation setAlignment={setAlignment} alignment={alignment} />}

        {/* <Box flexGrow={1} /> */}
        <Stack spacing={1} direction="row" alignItems="center" sx={{ ml: "auto" }}>
          {/* <Language /> */}
          {/* ------------------------------------------- */}
          {/* Ecommerce Dropdown */}
          {/* ------------------------------------------- */}
          {/* <Cart /> */}
          {/* ------------------------------------------- */}
          {/* End Ecommerce Dropdown */}
          {/* ------------------------------------------- */}
          <SmartAlertsDropdown />
          {/* ------------------------------------------- */}
          {/* Toggle Right Sidebar for mobile */}
          {/* ------------------------------------------- */}
          {lgDown ? <MobileRightSidebar /> : null}
          <Profile />
        </Stack>
      </ToolbarStyled>
    </AppBarStyled>
  );
}
